import * as actionTypes from './appSettingsActionTypes';

const initialState = {
    fetchActiveTransportOrdersTimeout: 5000,
    fetchCompletedTransportOrdersTimeout: 5000,
    fetchHiveStateTimeout: 5000
}

export default function appSettingsReducer(state = initialState, action) {

    switch (action.type) {
        case (actionTypes.SET_FETCH_ACTIVE_TRANSPORTORDERS_TIMEOUT):
            if (action.timeout !== state.fetchActiveTransportOrdersTimeout) {
                return Object.assign({}, state, { fetchActiveTransportOrdersTimeout: action.timeout });
            }
            return state;
        case (actionTypes.SET_FETCH_COMPLETED_TRANSPORTORDERS_TIMEOUT):
            if (action.timeout !== state.fetchCompletedTransportOrdersTimeout) {
                return Object.assign({}, state, { fetchCompletedTransportOrdersTimeout: action.timeout });
            }
            return state;
        case (actionTypes.SET_FETCH_HIVE_STATE_TIMEOUT):
            if (action.timeout !== state.fetchHiveStateTimeout) {
                return Object.assign({}, state, { fetchHiveStateTimeout: action.timeout });
            }
            return state;
        default:
            return state;
    }
}


